import React from 'react';
import { Image } from 'react-bootstrap';

const PRContent = (props) => {
    //content: text, image
    //content type
    let text = props?.text ? props.text : null;
    let typeId = props?.typeId ? props.typeId : null;
    let filepath = props?.filepath ? props.filepath : null;

    

    switch (typeId) {
        case null:
        case 1:
            return (
                <>
                    {text}
                </>
            )
            break;
        case 2:
        case 3:
            //if an image - optional 
            let width = props?.width ? props.width : null;
            let height = props?.height ? props.height : null;
            let size = props?.size ? props.size : null;
            let dimensions = {}
            switch (size) {
                case 'sm':
                    dimensions = { width: 100, heigh: 100 };
                    break;
                case 'md':
                    dimensions = { width: 256, heigh: 256 };
                    break;
                default:
                    if (width != null) {
                        dimensions.width = width;
                    }
                    if (height != null) {
                        dimensions.height = height;
                    }
                    break;
            }
            return (
                <>
                    <Image src={`https://storage.reconify.com/${filepath}`} {...dimensions} className='img-fluid'/>
                </>
            )
            break;
        case 4:
            return (
                <>
                    <pre className='function-pre'>
                    {JSON.stringify(JSON.parse(text),undefined,2)}
                    </pre>
                </>
            )
            break;
        default:
            return (
                <>
                    {text}
                </>
            )
            break;
    }
}

export default PRContent;